import { ApolloError } from '@apollo/client'
import { get } from 'lodash'
import { INotification, NotificationType } from '../types/notification'
import HttpStatusCode from '../../server/lib/http-codes'
import { IError } from '../types/error'

export const onError = (
  error: ApolloError,
  notificationFn: (notification: INotification) => void
): void => {
  notificationFn({ type: NotificationType.FAILURE, message: error.message })
}

export const toErrorCodes = (error?: ApolloError): HttpStatusCode => {
  return (
    get(error, 'graphQLErrors[0].extensions.exception.status') ||
    get(error, 'graphQLErrors[0].extensions.exception.statusCode') ||
    get(error, 'graphQLErrors[0].extensions.code') ||
    HttpStatusCode.INTERNAL_SERVER_ERROR
  )
}

export const isCartError = (error?: ApolloError | IError): boolean => {
  return (
    error?.message === 'GraphQL error: Checkout could not be found' ||
    error?.message === 'Item Not Found' ||
    error?.message === 'Cart Not Found'
  )
}

export const isPaymentError = (error?: ApolloError | IError): boolean =>
  !!error?.message?.includes(`This PaymentIntent's amount could not be updated`)
